import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Icon from 'components/atoms/Icons/Icon/Icon';

const StyledDealflowIcon = styled(Icon)`
  .DealflowIcon-text { 
    color: ${props => props.theme.property('palette.background.paper')};
    text-anchor: start;
    font-weight: bold;
  }
  
  ${ComponentStyles}
`;

StyledDealflowIcon.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowIcon;
